import React, { useState } from 'react';
import Calculator from '../pure/calculator';



function CalculatorContainer() {

  const [totalValue, setTotalValue] = useState("0.000")
  
  function Execute(
                  continent,
                  live,
                  diet,
                  wastepercent,
                  organicWaste,
                  solidWaste,
                  country,
                  electricity,
                  NaturalGas,
                  bottleCapacity,
                  manyBottles,
                  shortHaulKm,
                  mediumHaulKm,
                  longHaulKm,
                  longTrain,
                  shortTrain,
                  buss, 
                  petrol,
                  gnc,
                  motocicle) 
                  
    {
                  let continent1=parseFloat(continent);
                  let live1=parseFloat(live);
                  let diet1=parseFloat(diet);
                  let wastepercent1=parseFloat(wastepercent);
                  let organicWaste1=parseFloat(organicWaste);
                  let solidWaste1=parseFloat(solidWaste);
                  let country1=parseFloat(country);
                  let electricity1=parseFloat(electricity);
                  let NaturalGas1=parseFloat(NaturalGas);
                  let bottleCapacity1=parseFloat(bottleCapacity);
                  let manyBottles1=parseFloat(manyBottles);
                  //corta distancia
                  let shortHaulKm1
                  if(shortHaulKm >= 0 ){
                    shortHaulKm1=parseFloat(shortHaulKm);
                  }
                  if(shortHaulKm ==="" ){
                    shortHaulKm1=0;
                  }
                  //mediana distancia
                  let mediumHaulKm1
                  if(shortHaulKm >= 0 ){
                    mediumHaulKm1=parseFloat(mediumHaulKm);
                  }
                  if(mediumHaulKm ==="" ){
                    mediumHaulKm1=0;
                  }
                  //larga distancia
                  let longHaulKm1
                  if(longHaulKm >= 0 ){
                    longHaulKm1=parseFloat(longHaulKm);
                  }
                  if(longHaulKm ==="" ){
                    longHaulKm1=0;
                  }
                  //Tren Larga distancia
                  let longTrain1
                  if(longTrain >= 0 ){
                    longTrain1=parseFloat(longTrain);
                  }
                  if(longTrain ==="" ){
                    longTrain1=0;
                  }
                  //tren urbano
                  let shortTrain1
                  if(shortTrain >= 0 ){
                    shortTrain1=parseFloat(shortTrain);
                  }
                  if(shortTrain ==="" ){
                    shortTrain1=0;
                  }
                //Buss
                 let  buss1
                 if(buss >= 0 ){
                  buss1=parseFloat(buss);
                  }
                  if(buss ==="" ){
                    buss1=0;
                  }
                  //auto nafta
                  let petrol1
                  if(petrol >= 0 ){
                    petrol1=parseFloat(petrol);
                    }
                    if(petrol ==="" ){
                      petrol1=0;
                  }
                  //auto gas
                  let gnc1
                  if(gnc >= 0 ){
                    gnc1=parseFloat(gnc);
                    }
                    if(gnc ==="" ){
                      gnc1=0;
                  }
                  //moto
                  let motocicle1
                  if(motocicle >= 0 ){
                    motocicle1=parseFloat(motocicle);
                  }
                  if(motocicle ==="" ){
                    motocicle1=0;
                  }

                  //Calculo
     
                  setTotalValue(
                    (
                      //? WASTE &FOOD
            
                      ((((wastepercent1+(solidWaste1+organicWaste1))*live1)+
                      (diet1*live1))*continent1)+
            
                      //?electricity1
                      (country1*electricity1)+
            
                      //?GAS
                      ((2.21*NaturalGas1)+((bottleCapacity1 * manyBottles1)*2.96))+
            
                      //? TRAVELS
                      ((0.13867 * shortHaulKm1)+(0.136 * mediumHaulKm1)+(0.23963 * longHaulKm1)+
                      ((0.086 * shortTrain1)*260)+(0.07394*longTrain1)+((0.10391 * buss1)*260))+

                      //? VEHICLES
                      ((0.1491* petrol1)+(0.17616*gnc1)+(0.1198*motocicle1))  
            
                    )
                  );

  } 

  return (
   <div>

        <Calculator getValue={Execute} totalCO2={totalValue}/>
   </div>
  )
}

export default CalculatorContainer